<script lang="ts">
	import { get_recipes } from "../tastummy";
	import { onMount } from "svelte";
	import RecipeView from "./RecipeView.svelte";
	import { navigate } from "svelte-navigator";
	import RecipeActions from "./components/RecipeActions.svelte";
	import Loading from "../general/Loading.svelte";
	import { get_tags } from "../tastummy";
	import FilterPill from "../general/FilterPill.svelte";
	import type { Tag } from "./recipe.types";

	let loading = false;
	let recipes = [];
	let tags = [];
	let filter_tags = [];
	get_tags().then((r) => (tags = r.data));
	onMount(async () => {
		loading = true;
		let r = await get_recipes();
		loading = false;
		recipes = r.data;
	});
	$: filtered_recipes = recipes.filter(
		(item) =>
			item.tags.some((tag: Tag) => filter_tags.includes(tag.name)) ||
			filter_tags.length === 0
	);
</script>

<div class="view-recipe-holder">
	<h1 style="grid-column: 1 / -1">Your Recipes</h1>
	{#if loading}
		<Loading style="grid-column: 1 / -1" />
	{/if}
	<div class="tag-container grid-full">
		{#each tags as tag (tag.name)}
			<FilterPill
				selected={filter_tags.indexOf(tag.name) !== -1}
				on:click={(event) => {
					if (event.detail.isSelected) {
						filter_tags = filter_tags.filter((x) => x !== tag.name);
					} else {
						filter_tags.push(tag.name);
					}
					filter_tags = filter_tags;
				}}>{tag.name}</FilterPill
			>
		{/each}
	</div>
	{#each filtered_recipes as recipe (recipe.id)}
		<RecipeView
			{recipe}
			on:clicked={() => navigate(`/recipe/${recipe.id}`)}
		>
			<div class="recipe-buttons grid-full">
				<RecipeActions
					recipe_id={recipe.id}
					on:removed={() =>
						(recipes = recipes.filter((r) => r.id != recipe.id))}
				/>
			</div>
		</RecipeView>
	{/each}
</div>

<style>
	.view-recipe-holder {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
	}
	.recipe-buttons {
		display: flex;
		flex-direction: row-reverse;
		width: 100%;
	}
	.tag-container {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		justify-content: left;
		align-items: flex-start;
	}
	@media (min-width: 640px) {
		.view-recipe-holder {
			grid-template-columns: repeat(3, 1fr);
		}
	}
	@media (min-width: 900px) {
		.view-recipe-holder {
			grid-template-columns: repeat(4, 1fr);
		}
	}
	@media (min-width: 1200px) {
		.view-recipe-holder {
			grid-template-columns: repeat(6, 1fr);
		}
	}
</style>
